<template>
  <a-card :bordered="false">
    <div class="top">
      <div class="head">
        <h1><a href="#"><img src="@/assets/logo.png" style="max-width: 100%; height: auto;" /></a></h1>
      </div>
    </div>
    <div class="topimg">
      <img src="@/assets/banner2.png" alt="Image" style="max-width: 100%; height: auto;" />
    </div>

    <div class="newbox">
      <div class="table-page-search-wrapper search">
        <a-form class="nbox" layout="inline">
              <div class="sleft">
                <span style="display: flex;width: 40px;">年份</span>
                <a-date-picker
                    valueFormat="YYYY-MM-DD"
                    mode="year"
                    placeholder="请选择年份"
                    format="YYYY"
                    :allowClear="false"
                    v-model="queryParams.year"
                    :open="yearShowOne"
                    @openChange="openChangeOne"
                    @panelChange="panelChangeOne"
                />
              </div>
              <span class="sright">
                <a-button type="danger" @click="getList()">查询</a-button>
                <a-button style="margin-left: 8px" @click="restQuery()">重置</a-button>
              </span>
        </a-form>

        <div class="tj">
          <span>用户：<span v-if="userInfo && userInfo.fullName">{{userInfo.fullName}}</span></span>
          <span>工号：<span v-if="userInfo && userInfo.jdUserCode">{{userInfo.jdUserCode}}</span></span>
        </div>
        <div class="tj">
          <span>集中培训和集体学时：{{dataSum.pxxs}}</span>
          <span>网络自学：{{dataSum.wlxs}}</span>
        </div>
      </div>

      <div class="funbut">
        <a-button type="danger" @click="add">添加</a-button>
        <a-button icon="cloud-download" @click="template()">模板下载</a-button>
        <a-upload name="file" :showUploadList="false" :customRequest="handleImport">
          <a-button :icon="fileLoading ? 'loading' : 'upload'">导入</a-button>
        </a-upload>
      </div>
    </div>
      <!-- 列表 -->
      <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
        <van-list
            class="list-con"
            v-model="data.bottomLoading"
            :finished="!data.hasMore"
            finished-text="没有更多了"
            @load="bottomRefresh()"
        >
          <div class="list-box-new" v-for="(item, index) in data.records" :key="index">
                  <h2>姓名：{{ item.fullName }}</h2>
                  <span>主办单位: <p>{{item.organizeName}}</p></span>
                  <span>教育培训时间: <p>{{extractYMD(item.strTime)}} - {{extractYMD(item.endTime)}}</p></span>
                  <span>集中培训和集体学习学时数: <p>{{item.pxxs}}</p></span>
                  <span>网络自学培训学时: <p>{{item.wlxs}}</p></span>
                  <span>教育培训内容: <p>{{item.remark}}</p></span>
                  <div class="bfun">
                        <a @click="handleUpdate(item)" >编辑</a>
                        <a style="margin-left:10px" @click="handleDetail(item)" >详情</a>
                        <a-popconfirm title="您确认删除吗?" @confirm="handleDelete(item.id)" okText="确认" cancelText="取消">
                          <a style="margin-left:10px" href="javascript:void(0)">删除</a>
                        </a-popconfirm>
                  </div>
          </div>
        </van-list>
      </van-pull-refresh>

    <add-and-edit ref="add" :refresh="restQuery" />
    <detail ref="detail" />
  </a-card>
</template>
<script>
import 'ant-design-vue/es/message/style/css'; // 引入 Message 组件的样式
import {del, getUserInfo, getXsSum, importExcel, queryList, template} from "../../api/educationalTraining";
import 'ant-design-vue/dist/antd.css';
import {Card, Form, Row, Col, DatePicker, Button, Upload,  Popconfirm,} from 'ant-design-vue';
import addAndEdit from "./components/addAndEdit.vue";
import detail from "./components/detail.vue";
import moment from "moment/moment";
import {handlePageData} from '@/utils/common'
import Message from "ant-design-vue/lib/message";
export default {
  components: {
    addAndEdit,
    detail,
    'a-card': Card,
    'a-popconfirm': Popconfirm,
    'a-form': Form,
    'a-date-picker': DatePicker,
    'a-button': Button,
    'a-upload': Upload,
  },
  data () {
    return {
      Message,
      yearShowOne: false,
      fileLoading: false,
      pagination: {
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        current: 1, // 当前页数
        showSizeChanger: true,
        pageSizeOptions: ['10'], // 每页中显示的数据
      },
      list:[],
      // 查询参数
      queryParams:{year:moment( new Date()).format('YYYY')},
      // 列表表头
      data: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false,
        topLoading: false,
        bottomLoading: false
      },
      noticeTypeOptions: [],
      noticeOptions: [],
      noticeStatusOptions: [],
      dataSum:{},
      userInfo:{},
      // 单个记录行
      recordActive: {}
    }
  },
  created () {
    this.getList()
    getUserInfo().then(res =>{
      if (res.code === 10000){
        this.userInfo = res.result
      }
    })
  },
  computed: {},
  methods: {
    extractYMD(dateString) {
      // 先将日期字符串转换为 Date 对象
      const date = new Date(dateString.replace(' ', 'T')); // 替换空格为 'T'，确保能被解析为有效的 ISO 格式
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化为两位数
      const day = String(date.getDate()).padStart(2, '0'); // 保证天数是两位数
      return `${year}-${month}-${day}`;
    },
    add(){
      this.$refs.add.show()
    },
    handleUpdate(record){
      this.$refs.add.show(record.id)
    },
    handleDetail(record){
      this.$refs.detail.show(record.id)
    },

    refresh() {
      this.reset()
      this.getList()
    },
    reset() {
      this.data.current = 1
      this.data.total = 0
      this.data.hasMore = true
    },
    bottomRefresh() {
      if (this.data.current > 1 && this.data.hasMore)
        this.getList()
    },
    getList(){
      if (this.data.loading) return
      this.data.loading = true
      this.queryParams.current = this.data.current
      this.queryParams.size = this.data.size
      queryList( this.queryParams)
          .then(res => {
            if (res.code === 10000) {
              setTimeout(() => {
                this.data.records = []
                handlePageData(this.data, res.result)
              }, 100)
            }
          }).finally(() => {
        setTimeout(() => {
          this.data.loading = false
          this.data.topLoading = false
          this.data.bottomLoading = false
        }, 100)
      })

      getXsSum().then(res =>{
        if (res.code  === 10000){
          this.dataSum = res.result

        }
      })

    },
    handlePageChange(page, pageSize) {
      // 更新当前页数
      this.pagination.current = page;
      this.pagination.pageSize = pageSize;

      // 更新查询参数中的页数
      this.queryParams.page = page;
      this.queryParams.pageSize = pageSize;

      // 重新获取数据
      this.getList();
    },

    // 删除记录
    handleDelete (id) {
      del({ id: id }).then(res => {
        if (res.code === 10000) {
          Message.success('操作成功');
          this.restQuery()
        }
      })
    },

    /**
     * 导入
     */
    handleImport (data) {
      this.fileLoading = true
      importExcel(data.file).then(res => {
        if (res.code === 10000) {
          Message.success(res.result);

        }
      }).finally(() => {
        this.fileLoading = false
        this.getList()
      })
    },


    template(){
      template().then(res =>{
        if (res.code === 10000){
          Message.success(res.result);
        }
      })
    },
    // 弹出日历和关闭日历的回调
    openChangeOne (status) {
      // status是打开或关闭的状态
      if (status) {
        this.yearShowOne = true
      }
    },
// 得到年份选择器的值
    panelChangeOne (value) {
      this.queryParams.year = value
      this.yearShowOne = false
    },
    // 选择框搜索过滤
    filterOption (input, option) {
      return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) > -1)
    },
    // 重置查询
    restQuery () {
      this.queryParams.year  = moment( new Date()).format('YYYY')
      this.reset()
      this.getList()

    },


  }
}
</script>
<style scoped>
@media (max-width: 768px) {
  .head{
    padding:10px 16px;
  }
  .top img {
    width: 40%;
  }
.nbox{
  display: flex;
  justify-content: space-between;
}
.sleft{
  display: flex;
  flex: 1;
  margin-right: 10px;
}
  .sleft span{
    display: flex;
    align-items: center;
  }
.sright{
  display: flex;
  width: 138px;
}
  .table-page-search-wrapper {
    padding: 10px 16px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 20px;
  }

  .funbut {
    display: flex;
    align-items: center;
    padding: 0 16px;
  }
}
/deep/.ant-card-body{
  padding: 0 !important;
}
.funbut button{
  margin-right: 8px;
}
.tj{
  margin-top: 8px;
}
.list-con{
  padding: 0 16px;
}
.list-box-new{
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #ededed;
  border-radius: 6px;
  //box-shadow:0 0 10px rgba(0,0,0,0.1);
  background: #f7fcff;
}
.bfun{
  display: flex;
  align-items: center;
  margin-top: 6px;
}
.bfun a{
  display: flex;
  padding:2px 10px;
  color: #ff4d4f;
  background-color: #ffffff;
  border:1px solid #ff4d4f;
  border-radius: 6px;
}
.list-box-new h2{
  font-weight: bold;
  color: #333333;
  font-size: 15px;
  margin-bottom: 6px;
}
.list-box-new span{
  display: flex;
  align-items: flex-start;
  color: #777777;
  font-size: 13px;
  line-height: 24px;
}
.list-box-new span p{
  color: #666666;
  margin-left: 4px;
  display: flex;
  flex: 1;
}
</style>
